export default function CollectionImageForm() {
  collectionImageFormInit();
}

function collectionImageFormInit() {
  const form = document.getElementById("collection-image-form");
  if (!form) return;

  const imageInput = document.getElementById("CollectionImage");
  const imageValidationMessage = document.querySelector(
    ".collection-detail__validation-message"
  );
  const externalTriggers = document.querySelectorAll(
    ".js-collection-image-trigger"
  );

  const validImageTypes = JSON.parse(imageInput.dataset.fileTypes);
  const validImageSize = Number(imageInput.dataset.fileSize);
  const validTypesMessage = imageInput.dataset.valFileType;
  const validSizeMessage = imageInput.dataset.valFileSize;

  const fileInputHandler = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const isValidType = validImageTypes.some((type) =>
      file.name.toLowerCase().endsWith(type)
    );
    const isValidSize = file.size <= validImageSize;

    if (isValidType && isValidSize) {
      form.submit();
    } else {
      if (imageValidationMessage) {
        imageValidationMessage.style.display = "block";
        imageValidationMessage.textContent = `${validTypesMessage} ${validSizeMessage}`;
      } else {
        console.error(validTypesMessage, validSizeMessage);
      }
    }
  };

  if (imageInput) {
    imageInput.addEventListener("change", fileInputHandler);
  }

  externalTriggers?.forEach((trigger) => {
    trigger.addEventListener("click", onImageTriggerClick);
  });

  function onImageTriggerClick() {
    if (!imageInput) return;
    imageInput.click();
  }
}
